//
import DefaultAvatar from 'assets/img/icons/avatar-default.png';
import { ChatbotTestController } from '../chatbotTest/ChatbotTestController';
import ChatbotTestView from '../chatbotTest/ChatbotTestView.html';
import * as ArrowB from 'assets/img/ArrowB.png';
import './SubheaderDetail.scss';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { FlowViewModelValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/FlowViewModelValidator';
import { GlobalStateViewModelValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/GlobalStateViewModelValidator';
import { builderStateName } from 'modules/application/detail/portal-submodule-builder/templates/builder';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { DeleteApplicationModalController } from 'modules/application/detail/configurations/basic/DeleteApplicationModal/DeleteApplicationModalController';
import DeleteApplicationModalView from 'modules/application/detail/configurations/basic/DeleteApplicationModal/DeleteApplicationModalView.html';
import { builderObservabilityMonitoringStateName } from 'modules/application/detail/builderObservability';
import { PlanStatus } from 'modules/application/detail/portal-submodule-builder/templates/builder/studio/types/plan';
export const UNDER_CONSTRUCTION_TESTING = 'construction';
export class SubheaderDetailController {
    static $inject = ['$rootScope', '$state', 'BLIPWEBURI', 'MenuItemsService', 'AuthenticationService', 'ApplicationService2', '$interval', '$scope', 'SidebarContentService', 'ChatbotSettingsService', '$document', 'PermissionsService', '$translate', 'SegmentService', 'BlipToastService', 'BuilderService', 'LoadingService', 'ApplicationTeamService', 'APPLICATION_DEFAULT_IMAGE', 'CurrentApplicationService', 'SubflowService', 'AiAgentService', 'MessagingHubService', 'ConfigurationsSegmentService', 'ModalService', 'ngToast', '$timeout', 'StudioService'];
    constructor($rootScope, $state, BLIPWEBURI, MenuItemsService, AuthenticationService, ApplicationService2, $interval, $scope, SidebarContentService, ChatbotSettingsService, $document, PermissionsService, $translate, SegmentService, BlipToastService, BuilderService, LoadingService, ApplicationTeamService, APPLICATION_DEFAULT_IMAGE, CurrentApplicationService, SubflowService, AiAgentService, MessagingHubService, ConfigurationsSegmentService, ModalService, ngToast, $timeout, StudioService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.BLIPWEBURI = BLIPWEBURI;
        this.MenuItemsService = MenuItemsService;
        this.AuthenticationService = AuthenticationService;
        this.ApplicationService2 = ApplicationService2;
        this.SidebarContentService = SidebarContentService;
        this.ChatbotSettingsService = ChatbotSettingsService;
        this.$document = $document;
        this.PermissionsService = PermissionsService;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.BuilderService = BuilderService;
        this.LoadingService = LoadingService;
        this.ApplicationTeamService = ApplicationTeamService;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.CurrentApplicationService = CurrentApplicationService;
        this.SubflowService = SubflowService;
        this.AiAgentService = AiAgentService;
        this.MessagingHubService = MessagingHubService;
        this.ConfigurationsSegmentService = ConfigurationsSegmentService;
        this.ModalService = ModalService;
        this.ngToast = ngToast;
        this.$timeout = $timeout;
        this.StudioService = StudioService;
        this.isAttendance = false;
        this.hasPermissions = {};
        this.arrowBPath = ArrowB;
        this.leaveBotAlert = 'leave-bot-alert';
        this.leaveBotOnlyAdminAlert = 'leave-bot-only-admin-alert';
        this.isEditableFlowTestEnabled = false;
        this.isBuilderObservabilityEnabled = false;
        this.enableConstructionTest = true;
        this.isSubflowApplication = false;
        this.isOnline = false;
        this.hasTooltip = false;
        this.isAiAgent = false;
        this.isRouter = false;
        this.isTrialCheckEnabled = false;
        this.createTrack = async (trackClick) => {
            if (!trackClick) {
                return;
            }
            try {
                const application = await this.CurrentApplicationService.fetchApplication();
                this.SegmentService.createApplicationTrack({
                    trackEvent: trackClick,
                    application,
                });
            }
            catch (e) {
                console.error(e);
            }
        };
        this.openTest = (typeOfCompile) => {
            this.showBlipChatSidenav(typeOfCompile);
        };
        this.openUnitTest = () => {
            this.$state.go(builderObservabilityMonitoringStateName, {
                applicationShortName: this.application.shortName,
            });
        };
        this.addUnitTestIcon = () => {
            const testDetailsMenu = this.$document[0].querySelector('ul.test-details-menu');
            if (testDetailsMenu) {
                const existingUnitTestItem = testDetailsMenu.querySelector('a[data-cy="link-unit-test"]');
                if (existingUnitTestItem) {
                    return;
                }
                const hrefUri = this.$state.href(builderObservabilityMonitoringStateName);
                const unitTestLi = this.$document[0].createElement('li');
                unitTestLi.className = 'enabled';
                const unitTestLink = this.$document[0].createElement('a');
                unitTestLink.className = 'bp-c-cloud tooltip-icon-hover';
                unitTestLink.setAttribute('data-cy', 'link-unit-test');
                unitTestLink.setAttribute('style', 'width: 100%;cursor: pointer;');
                unitTestLink.setAttribute('href', hrefUri);
                unitTestLink.setAttribute('ui-sref', builderObservabilityMonitoringStateName);
                unitTestLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.openUnitTest();
                });
                const bdsGridInside = this.$document[0].createElement('bds-grid');
                bdsGridInside.setAttribute('justify-content', 'space-between');
                bdsGridInside.setAttribute('align-items', 'center');
                const bdsGridOutside = this.$document[0].createElement('bds-grid');
                bdsGridOutside.setAttribute('justify-content', 'space-between');
                bdsGridOutside.setAttribute('align-items', 'center');
                const bdsTypo = this.$document[0].createElement('bds-typo');
                bdsTypo.setAttribute('variant', 'fs-15');
                bdsTypo.setAttribute('translate', '');
                bdsTypo.textContent = this.isRouter
                    ? this.$translate.instant('modules.application.detail.monitoring')
                    : this.$translate.instant('modules.application.detail.unitTests');
                const bdsTooltip = this.$document[0].createElement('bds-tooltip');
                bdsTooltip.setAttribute('translate', '');
                bdsTooltip.setAttribute('tooltip-text', this.isRouter
                    ? this.$translate.instant('modules.application.detail.monitoring')
                    : this.$translate.instant('modules.application.detail.unitTests'));
                const bdsIcon = this.$document[0].createElement('bds-icon');
                bdsIcon.setAttribute('size', 'medium');
                bdsIcon.setAttribute('name', this.isRouter ? 'message-talk' : 'resources');
                bdsIcon.setAttribute('theme', 'outline');
                bdsIcon.setAttribute('class', 'unit-test-icon');
                const bdsChipTag = this.$document[0].createElement('bds-chip-tag');
                bdsChipTag.setAttribute('color', 'success');
                bdsChipTag.setAttribute('translate', '');
                bdsChipTag.textContent = this.$translate.instant('modules.application.detail.unitTestsChipTag');
                bdsGridInside.appendChild(bdsTooltip);
                bdsGridInside.appendChild(bdsTypo);
                bdsTooltip.appendChild(bdsIcon);
                bdsGridOutside.appendChild(bdsGridInside);
                bdsGridOutside.appendChild(bdsChipTag);
                unitTestLink.appendChild(bdsGridOutside);
                unitTestLi.appendChild(unitTestLink);
                testDetailsMenu.appendChild(unitTestLi);
            }
        };
        this.arrowBPath = ArrowB;
        this.defaultAvatar = DefaultAvatar;
        this.onInit();
        this.setup();
        // Ping the application
        const pingPromise = $interval(() => this.checkApplicationStatus(), 30000);
        $scope.$on('$destroy', () => $interval.cancel(pingPromise));
    }
    async onInit() {
        await this.checkFeatures();
        this.isAiAgent = await this.AiAgentService.checkAiAgentAsync();
        this.flowViewModelValidator = new FlowViewModelValidator();
        this.globalStateViewModelValidator = new GlobalStateViewModelValidator();
    }
    async checkFeatures() {
        this.isEditableFlowTestEnabled = await BuilderFeatures.testBucketFlow();
        this.isBuilderObservabilityEnabled = await this.StudioService.shouldEnableStudioFeatures();
        const planStatus = await this.StudioService.shouldShowTrialRegisterOption();
        this.isTrialCheckEnabled = planStatus === PlanStatus.AVAILABLE_TO_TRIAL || planStatus === PlanStatus.AVAILABLE_TO_UPGRADE;
    }
    isActive(state) {
        return this.$state.includes(state);
    }
    async setup() {
        try {
            this.application = this.$rootScope.application;
            this.isSubflowApplication = this.application.isSubflow;
            this.isRouter = this.application.template === 'master';
            if (this.isSubflowApplication) {
                const result = await this.SubflowService.get(this.application.shortName);
                if (!result) {
                    this.subflowName = this.application.name;
                    this.subflowImageUri = this.application.imageUri;
                }
                else {
                    this.subflowName = result.configuration.name;
                    this.subflowImageUri = result.configuration.image;
                }
            }
            this.enableConstructionTest = this.application.template === 'builder';
            this.menuItems = await this.MenuItemsService.getUpdatedMenus();
            this.menuIcons = await this.MenuItemsService.getMenuIcons();
            // Add unit test icon dynamically after component loads
            this.$timeout(() => {
                if (this.isBuilderObservabilityEnabled) {
                    this.addUnitTestIcon();
                }
            }, 1000);
            this.blipWebUri = this.BLIPWEBURI.replace('%identifier', this.application.shortName).replace('%accessKey', this.application.accessKey);
            //Check permissions for the chatbot dropdown item
            this.checkPermissions();
            //Check application status (online || offline)
            this.checkApplicationStatus();
        }
        catch (e) {
            console.error(e);
        }
        const tooltipText = this.application.template === 'builder' ? 'modules.application.detail.tooltipTextTest' : 'modules.application.detail.tooltipTextRouterTest';
        this.infoText = await this.$translate(tooltipText);
    }
    async checkApplicationStatus() {
        this.isOnline = await this.ApplicationService2.isOnline(this.application);
        this.hasTooltip = this.application.template === 'master' ? true : !this.isOnline;
        this.application.status = this.isOnline ? 'online' : 'offline';
    }
    async checkPermissions() {
        const configPermissions = await Promise.all([
            this.PermissionsService.hasPermissions('read', 'basicConfigurations'),
            this.PermissionsService.hasPermissions('read', 'connectionInformations'),
        ]);
        const configName = 'config';
        this.hasPermissions[configName] = configPermissions.some((res) => res);
    }
    goToConfigurations() {
        if (this.application.applicationUserPermissionModel.some((p) => (p.permissionClaim === 109 && p.permissionAction > 0) ||
            (p.permissionClaim === 110 && p.permissionAction > 0))) {
            this.$state.go('auth.application.detail.configurations');
        }
    }
    goToBlipWebAttendance() {
        window.open(this.AuthenticationService.getAuthRedirectUrl(this.blipWebUri.split('?')[0]), '_blank');
    }
    async CancelLeaveProject() {
        this.SegmentService.createOrganizationTrack('portal-cancel-leave-project', {
            'applicationId': this.application.shortName,
            'email': this.AuthenticationService.email,
        });
        await this.ToggleAlert(this.leaveBotAlert);
    }
    async LeaveProject() {
        this.SegmentService.createOrganizationTrack('portal-leave-project', {
            'applicationId': this.application.shortName,
            'email': this.AuthenticationService.email,
        });
        await this.ToggleAlert(this.leaveBotAlert);
        try {
            this.LoadingService.startLoading();
            await this.ApplicationTeamService.deleteApplicationUser(this.application.shortName, this.AuthenticationService.email);
            this.$state.go('auth.application.list');
            const success36 = await this.$translate('utils.successMsg.36');
            this.BlipToastService.show('success', { msg: success36 });
        }
        catch (err) {
            this.LoadingService.stopLoading();
            const error = JSON.parse(err);
            console.error(err);
            if (error && error.reason && error.reason.code === 67) {
                const permissionDenied = await this.$translate('contact.leavePermissionDenied');
                this.BlipToastService.show('warning', {
                    msg: permissionDenied,
                });
            }
            else {
                const error133 = await this.$translate('utils.errorMsg.133');
                this.BlipToastService.show('danger', { msg: error133 });
            }
        }
    }
    async CancelOnlyAdminLeave() {
        this.SegmentService.createOrganizationTrack('portal-cancel-leave-project-only-admin', {
            'applicationId': this.application.shortName,
            'email': this.AuthenticationService.email,
        });
        await this.ToggleAlert(this.leaveBotOnlyAdminAlert);
    }
    async GoToTeam() {
        this.SegmentService.createOrganizationTrack('portal-leave-project-only-admin-go-to-team', {
            'applicationId': this.application.shortName,
            'email': this.AuthenticationService.email,
        });
        await this.ToggleAlert(this.leaveBotOnlyAdminAlert);
        this.$state.go('auth.application.detail.team');
    }
    async ToggleAlert(alertId) {
        const bdsAlert = document.querySelector(`bds-alert[id=${alertId}]`);
        await bdsAlert.toggle();
    }
    async leaveBot() {
        const isOnlyAdmin = await this.ApplicationService2.isUserOnlyAdmin(this.application.shortName);
        if (isOnlyAdmin == 'True') {
            await this.ToggleAlert(this.leaveBotOnlyAdminAlert);
        }
        else {
            await this.ToggleAlert(this.leaveBotAlert);
        }
    }
    async openDeleteApplicationModal() {
        const deleteApplicationModal = await this.ModalService.showModal({
            template: DeleteApplicationModalView,
            controller: DeleteApplicationModalController,
            controllerAs: '$ctrl',
            inputs: {
                shortName: this.application.shortName,
            },
        });
        const confirmation = await deleteApplicationModal.close;
        if (confirmation) {
            await this.delete();
            this.trackChatbotDeleted();
        }
    }
    trackChatbotDeleted() {
        this.ConfigurationsSegmentService.trackChatbotDeleted();
    }
    async delete() {
        this.LoadingService.startLoading();
        try {
            // Delete application on Iris server
            this.application.messagingHubCommandWithDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            await this.ApplicationService2.deleteAndRevokeApplication(this.application);
            const successMessage = await this.$translate('modules.application.detail.edit.deleteSuccessMessage');
            this.ngToast.success(successMessage);
            this.$state.go('auth.application.list');
            // Close the connection
            this.MessagingHubService.closeClient(this.application);
        }
        catch (err) {
            const errorMessage = await this.$translate('modules.application.detail.edit.deleteErrorMessage');
            this.ngToast.danger(errorMessage);
        }
        finally {
            this.trackChatbotDeleted();
            this.LoadingService.stopLoading();
        }
    }
    async showBlipChatSidenav(typeOfCompile) {
        try {
            if (typeOfCompile === UNDER_CONSTRUCTION_TESTING) {
                if (!(await this.ChatbotSettingsService.isBuilderActive(this.application))) {
                    const errorMsg105 = this.$translate.instant('utils.errorMsg.114');
                    this.BlipToastService.show('warning', { msg: errorMsg105 });
                    return;
                }
                const flow = await this.BuilderService.getFlow(this.application);
                const configuration = await this.BuilderService.getFlowConfiguration();
                const globalActions = await this.BuilderService.getGlobalActionsFromBucketOrNew();
                try {
                    this.flowViewModelValidator.validate(flow);
                    this.globalStateViewModelValidator.validate(globalActions);
                }
                catch (e) {
                    console.error(e);
                    const errorMsg105 = this.$translate.instant('utils.errorMsg.105');
                    this.BlipToastService.show('warning', {
                        msg: errorMsg105,
                    });
                    return;
                }
                this.LoadingService.startLoading();
                try {
                    await this.BuilderService.publishFlow(flow, configuration, globalActions, this.application, this.application.flowId, typeOfCompile);
                }
                catch (ex) {
                    console.error(ex);
                }
                finally {
                    this.LoadingService.stopLoading();
                }
            }
            this.sidenav = await this.SidebarContentService.showSidebar({
                controller: ChatbotTestController,
                controllerAs: '$ctrl',
                template: ChatbotTestView,
                appendToElement: this.$document[0].getElementById('right-sidebar'),
                inputs: {
                    application: this.application,
                    ApplicationService2: this.ApplicationService2,
                    typeOfCompile,
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async backToMainFlow() {
        this.$state.go(builderStateName, { shortName: this.application.callerApplication.shortName, callerSubflow: this.application.shortName, selectedNodeId: undefined });
    }
}
SubheaderDetailController.$inject = ['$rootScope', '$state', 'BLIPWEBURI', 'MenuItemsService', 'AuthenticationService', 'ApplicationService2', '$interval', '$scope', 'SidebarContentService', 'ChatbotSettingsService', '$document', 'PermissionsService', '$translate', 'SegmentService', 'BlipToastService', 'BuilderService', 'LoadingService', 'ApplicationTeamService', 'APPLICATION_DEFAULT_IMAGE', 'CurrentApplicationService', 'SubflowService', 'AiAgentService', 'MessagingHubService', 'ConfigurationsSegmentService', 'ModalService', 'ngToast', '$timeout', 'StudioService'];
